import { App } from 'vue';
import Slider from '@vueform/slider';
import '@vueform/slider/themes/default.css';

export default function config(app: App) {
    app.component('InputSlider', Slider);
}